'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
mmWidgets.fn.crowdlinkSharingWidget = function (mapSharingModel) {
	if (!mapSharingModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			showCrowdlink = (crowdlink) => {
				if (crowdlink) {
					Object.keys(crowdlink).forEach(key => {
						if (key === 'url') {
							element.find(`[data-mm-role~="crowdlink.url-input"]`).val(crowdlink.url).attr('data-mm-val', crowdlink.url);
							element.find(`[data-mm-role~="crowdlink.url-link"]`).attr('href', crowdlink.url);
						} else {
							element.find(`[data-mm-role~="crowdlink.${key}"]`).text(crowdlink[key]);
						}
					});
				}
				if (crowdlink?.url) {
					element.showSection('crowdlink-active');
				} else {
					element.showSection('crowdlink-not-active');
				}
			},
			onContext = (context) => {
				if (context.tab !== 'crowdlink') {
					return;
				}
				showCrowdlink(context.crowdlink);
			},
			createCrowdlink = () => {
				const password = element.find('[name="crowdlink-password"]').val(),
					timeLimitHours = parseInt(element.find('[name="crowdlink-expiration-hours"]').val()),
					accessLevel =  element.find('[name="crowdlink-access-level"]').val();
				return mapSharingModel.createPublicUrl({password, timeLimitHours, accessLevel});
			};
		element.on('show', () => {
			mapSharingModel.addEventListener('context', onContext);
		});
		element.on('hide', () => {
			mapSharingModel.removeEventListener('context', onContext);
		});
		element.find('[data-mm-role~="create-crowdlink"]').click(createCrowdlink);
	});

};
